class Shoppingcart {
	constructor() {
		if ($('#deliver_address').length < 1) {
			return;
		}

		this.initEvents();
	}

	initEvents() {
		$('#deliver_address').off('delivery');
		$('#deliver_address').on('change.delivery', 'select[name="deliver_address_id"]', this.changeDeliverAddress.bind(this));
		$('#deliver_address').on('change.delivery', ':input', this.updateAddressInSummary.bind(this));
	}

	changeDeliverAddress(event) {
		let $select = $(event.target);
		let $option = $select.find('option:selected');
		let addressData = $option.data('addressInfo');

		$('#deliver_address').find('input[name="shipping_street"]').val(addressData.street);
		$('#deliver_address').find('input[name="shipping_street_number"]').val(addressData.street_number);
		$('#deliver_address').find('input[name="shipping_street_number_extra"]').val(addressData.street_number_extra);
		$('#deliver_address').find('input[name="shipping_company"]').val(addressData.company);
		$('#deliver_address').find('input[name="shipping_zipcode"]').val(addressData.zipcode);
		$('#deliver_address').find('input[name="shipping_town"]').val(addressData.town);
		$('#deliver_address').find('input[name="shipping_initials"]').val(addressData.initials);
		$('#deliver_address').find('input[name="shipping_lastname"]').val(addressData.lastname);
		$('#deliver_address').find('input[name="shipping_middlename"]').val(addressData.middlename);
		$('#deliver_address').find('input[name="shipping_phone"]').val(addressData.phone);
		$('#deliver_address').find('input[name="shipping_phone_backup"]').val(addressData.phone_backup);
		$('#deliver_address').find('input[name="shipping_mailbox"]').val(addressData.mailbox);
		$('#deliver_address').find('select[name="shipping_country"]').val(addressData.country.id).trigger('change');
	}

	updateAddressInSummary(event) {
		let $source = $('#deliver_address');
		let $target = $('.user-summary-delivery');
		if ($source.find('input[name="send_other_address"]').val() == 'nee') {
			this.updateAddressByInvoiceAddress();
		} else {
			$target.find('[data-name="shipping_company"]').html($source.find('input[name="shipping_company"]').val());
			let nameParts = [
				$source.find('input[name="shipping_initials"]:first').val(),
				$source.find('input[name="shipping_middlename"]:first').val(),
				$source.find('input[name="shipping_lastname"]:first').val()
			];
			let name = nameParts.filter(function (val) {
				return val != '';
			}).join(' ');
			$target.find('[data-name="shipping_name"]').html(name);
			$target.find('[data-name="shipping_street"]').html($source.find('input[name="shipping_street"]').val());
			$target.find('[data-name="shipping_street_number"]').html($source.find('input[name="shipping_street_number"]').val());
			$target.find('[data-name="shipping_street_number_extra"]').html($source.find('input[name="shipping_street_number_extra"]').val());
			$target.find('[data-name="shipping_zipcode"]').html($source.find('input[name="shipping_zipcode"]').val());
			$target.find('[data-name="shipping_town"]').html($source.find('input[name="shipping_town"]').val());
			$target.find('[data-name="shipping_country"]').html($source.find('select[name="shipping_country"] option:selected').html());
		}
	}

	updateAddressByInvoiceAddress() {
		let $source = $('.address-invoice');
		let $target = $('.user-summary-delivery');
		$target.find('[data-name="shipping_company"]').html($source.find('input[name="company"]').val());
		$target.find('[data-name="shipping_street"]').html($source.find('input[name="street"]').val());
		$target.find('[data-name="shipping_street_number"]').html($source.find('input[name="street_number"]').val());
		$target.find('[data-name="shipping_street_number_extra"]').html($source.find('input[name="street_number_extra"]').val());
	}
}

export default new Shoppingcart();